<template>
  <div id="coastalHabs" v-if="data['COASTAL']" class="q-ml-lg q-pa-sm" v-bind="attrs">
    <q-expansion-item  dense class="exp-panel-border"  group="coastalHab" :header-class="presentClass('wetlands')" :expand-icon-class="presentClass('wetlands') === 'flag-box-present' ? 'text-white' : 'text-dark'">
      <template v-slot:header >
         <div :style="{width: '100%'}">
            <div class="text-h6 text-bold" v-if="Object.keys(coastalData['wetlands']).length>0">
                <span v-if="coastalData['wetlands'].totalWetlandPerc >=1">{{  coastalData['wetlands'].totalWetlandPerc }}<span class="text-body2">% of total area with WETLANDS</span></span>
                <span v-else-if="coastalData['wetlands'].totalWetlandPerc <1 && coastalData['wetlands'].totalWetlandPerc >0">&lt;1<span class="text-body2">% of total area with WETLANDS</span></span>
                <span v-else class="text-body2">No wetland habitat estimated</span>
            </div>                
          </div>
      </template>
        <div class="text-center text-body1  q-pb-sm">
          Wetlands
          <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['wetlands'].model = !dataConsiderations['wetlands'].model" aria-label="Wetland data help"/>
        </div>
        <q-separator />
        <div class="text-h7 underline text-uppercase text-left q-pl-sm text-bold">Total Area</div>
        <div v-if="Object.keys(coastalData['wetlands']).length >0 && coastalData['wetlands']['totalWetlandPerc'] >0" class="row justify-center items-center ">
          <div v-if="Object.keys(coastalData['wetlands']).length >0" class="row items-center text-body2 q-pl-sm">
            <div class="col-12 text-left q-pb-sm  q-pl-sm">Total area of wetlands within: {{ Math.round(coastalData['wetlands']['totalWetlandArea']/1000000)  }}km<sup>2</sup></div>
            
            <div class="text-h7 underline text-uppercase text-left text-bold">By type</div>
            <div class="col-12 text-left q-pb-sm q-pl-sm">The types of coastal marshes within the area include:</div>
            <div class="col-9 self-center">
              <StackedBar 
                :data="coastalData['wetlands']['wetlandBar']" 
                divName="wetlandBar" 
                categoryProp="category" 
                barName="wetlandBar" 
                valueProp="value" 
                class="q-mt-none" 
                :xAxisTicks="false"
                :categoryColors="wetlandBarColors"
                :topMargin="0"    
                :leftMargin="0"  
                :rectOutline="true"                                 
              />
            </div>
            <div class="col-1 self-center">
              <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['wetlands'].model = !infoDialogs['wetlands'].model" aria-label="Coastal wetland data help"/>
            </div>
            <div class="col-1 items-center self-center q-mb-xs bordered pointer" @click="rowClick('CMAX')" :class="mapStyleInfo['attr'] == 'CMAX' ? 'mapActive' : ''">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'CMAX'" name="chevron_right"></q-icon>
                <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
                <q-tooltip>View this data in the map</q-tooltip>
            </div>
            <div class="col-12">
              <q-expansion-item label="Expand legend" class="text-right">
                <div class="row text-caption" v-for="obj in coastalData['wetlands']['wetlandBar']" :key="obj.category"><span class="q-ma-xs" :style="{'background-color': wetlandBarColors[obj.category[0]], 'width' :'10px'}"></span>{{ obj.category[0] }}: {{  obj.value }}%</div>
              </q-expansion-item>
            </div>

          </div>
          <div v-if="Object.keys(coastalData['wetlands']).length >0" class="row items-center text-body2 q-pa-sm q-pt-md">
            <div class="text-h7 underline text-uppercase text-left text-bold">Condition</div>
            <div class="col-12 text-left q-pb-sm q-pl-sm">Vulnerability of coastal marshes within the area:</div>
            <div class="col-9">
              <StackedBar 
                :data="coastalData['wetlands']['wetlandVulnBar']" 
                divName="wetlandVulnBar" 
                categoryProp="category" 
                barName="wetlandVulnBar" 
                valueProp="value" 
                class="q-mt-none" 
                :xAxisTicks="false"
                :categoryColors="wetlandVulnBarColors"
                :topMargin="0"    
                :leftMargin="0"  
                :rectOutline="true"                                 
                />
            </div>
            <div class="col-1">
              <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['wetlandVuln'].model = !infoDialogs['wetlandVuln'].model" aria-label="Wetland vulnerability data help"/>
            </div>
            <div class="col-1 items-center self-center bordered q-mb-xs pointer" @click="rowClick('UVVR')"  :class="mapStyleInfo['attr'] == 'UVVR' ? 'mapActive' : ''">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'UVVR'" name="chevron_right"></q-icon>
                <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
                <q-tooltip>View this data in the map</q-tooltip>
            </div>


            <div class="col-12">
              <q-expansion-item label="Expand legend" class="text-right">
                <div class="row text-caption" v-for="obj in coastalData['wetlands']['wetlandVulnBar']" :key="obj.category">
                  <span class="q-ma-xs" :style="{'background-color': wetlandVulnBarColors[obj.category], 'width' :'10px'}"></span>
                  {{ obj.category }}: {{  Math.round(obj.value) }}%
                </div>
              </q-expansion-item>

            </div>
          </div>
        </div>
        <div v-else class="q-pa-sm">
          No coastal marshes are located in the AOI.
        </div>
    </q-expansion-item>


    <q-expansion-item dense class="exp-panel-border"  group="coastalHab" :header-class="presentClass('sav')" :expand-icon-class="presentClass('sav') === 'flag-box-present' ? 'text-white' : 'text-dark'">
      <template v-slot:header >
         <div :style="{width: '100%'}">
            <div class="text-h6 text-bold text-left" v-if="Object.keys(coastalData['sav']).length>0">
                  <span v-if="coastalData['sav'].currentSAVPerc >=1">{{  coastalData['sav'].currentSAVPerc }}<span class="text-body2">% of total area with SEAGRASS</span></span>
                  <span v-else-if="coastalData['sav'].currentSAVPerc <1 && coastalData['sav'].currentSAVPerc >0">&lt;1<span class="text-body2">% of total area with SEAGRASS</span></span>
                  <span v-else class="text-body2">No seagrass habitat estimated</span>
              </div>
          </div>
      </template>
      <div class="text-center text-body1 q-pb-sm">
        Seagrass
        <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['sav'].model = !dataConsiderations['sav'].model" aria-label="SAV data help"/>
      </div>
      <q-separator/>
      <div v-if="Object.keys(coastalData['sav']).length >0" class="row items-center text-body2 q-pa-sm">
        <div class="col-12 text-left text-uppercase text-bold underline q-mt-sm">Presence</div>
        <div class="col-10 q-pl-sm self-center">
          <div class="text-body2 text-left q-pl-sm">
            <span  class="text-bold">{{ Math.round(coastalData['sav']['currentSAVArea']/1000000 *100)/100 }}</span> km<sup>2</sup> of seagrass / sub-aquatic vegetation
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['sav'].model = !infoDialogs['sav'].model" aria-label="SAV / eelgrass data help"/>

          </div>
        </div>
        <div class="col-1  q-mb-xs bordered pointer" @click="rowClick('SEAG')" :class="mapStyleInfo['attr'] == 'SEAG' ? 'mapActive' : ''">
          <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'SEAG'" name="chevron_right"></q-icon>
          <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
          <q-tooltip>View this data in the map</q-tooltip>
        </div>

        <div class="col-12 text-left text-uppercase text-bold underline q-mt-sm">Persistence<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['savPers'].model = !infoDialogs['savPers'].model" aria-label="SAV / eelgrass data help"/></div>
        <div class="col-12 text-body2 text-left q-pa-sm"  v-if="coastalData['sav']['savHVHPersistence'] >0">
          Of the portions of the area with SAV,
          <span v-if="coastalData['sav']['savHVHPersistence'] >1" class="text-bold">{{ Math.round(coastalData['sav']['savHVHPersistence'])  }}%</span>
          <span v-else-if="coastalData['sav']['savHVHPersistence'] <1 && coastalData['sav']['savHVHPersistence'] >0" class="text-bold">&lt;1% </span> 
          <span v-else>none </span> have HIGH or VERY HIGH persistence
        </div>
        <div class="col-10 q-pl-sm self-center">
          <StackedBar 
            v-if="coastalData['sav']['savPersistenceBar'][0].value >=0"
              :data="coastalData['sav']['savPersistenceBar']" 
              divName="savPersBar" 
              categoryProp="category" 
              barName="savPersBar" 
              valueProp="value" 
              class="q-mt-none" 
              :xAxisTicks="false"
              :categoryColors="savPersistenceBarColors"
              :topMargin="0"    
              :leftMargin="0"  
              :rectOutline="true"                                 
          />
          <div v-else>No persistence data is availabe in this area</div>
        </div>     
        <div class="col-1 items-center self-center q-mb-xs bordered pointer" @click="rowClick('PERS')" :class="mapStyleInfo['attr'] == 'PERS' ? 'mapActive' : ''">
            <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'PERS'" name="chevron_right"></q-icon>
            <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
            <q-tooltip>View this data in the map</q-tooltip>
        </div>

        <div class="col-12" v-if="coastalData['sav']['savPersistenceBar'][0].value >=0">
          <q-expansion-item label="Expand legend" class="text-right">
                <div class="row text-caption" v-for="obj in coastalData['sav']['savPersistenceBar']" :key="obj.category"><span class="q-ma-xs" :style="{'background-color': savPersistenceBarColors[obj.category[0]], 'width' :'10px'}"></span>{{ obj.category[0] }}: {{  obj.value }}%</div>
          </q-expansion-item>
        </div>

      </div>
      <div class="row q-pa-sm">
        <div class="col-12 text-left text-uppercase text-bold underline">Last Surveyed<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['savLast'].model = !infoDialogs['savLast'].model" aria-label="SAV / eelgrass data help"/></div>
        <div class="col-12 text-left q-pl-sm" v-if="arrayFindObjectByProp(coastalData['sav']['savDecadesBar'], 'category', '2020s').value">
          <span class="text-bold">
            {{ arrayFindObjectByProp(coastalData['sav']['savDecadesBar'], "category", '2020s').value }}
          </span>
          % of the area of interest surveyed since 2020
        </div>
        <div v-else class="col-12 text-left q-pl-sm">None of the area of interest has been surveyed since 2020.</div>
        <div class="col-10 q-pl-sm" >
          <StackedBar 
              v-if="coastalData['sav']['savDecadesBar'][0].value >=0"
              :data="coastalData['sav']['savDecadesBar']" 
              divName="savDecadesBar" 
              categoryProp="category" 
              barName="savDecadesBar" 
              valueProp="value" 
              class="q-mt-none" 
              :xAxisTicks="false"
              :categoryColors="savDecadesBarColors"
              :topMargin="0"    
              :leftMargin="0"  
              :rectOutline="true"                                 
          />
        </div>
        <div class="col-1 items-center self-center q-mb-xs bordered pointer" @click="rowClick('LASTSV')" :class="mapStyleInfo['attr'] == 'LASTSV' ? 'mapActive' : ''">
            <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'LASTSV'" name="chevron_right"></q-icon>
            <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
        </div>
        <div class="col-12" v-if="coastalData['sav']['savDecadesBar'][0].value >=0">
          <q-expansion-item label="Expand legend" class="text-right">
                <div class="row text-caption" v-for="obj in coastalData['sav']['savDecadesBar']" :key="obj.category"><span class="q-ma-xs" :style="{'background-color': savDecadesBarColors[obj.category[0]], 'width' :'10px'}"></span>{{ obj.category[0] }}: {{  obj.value }}%</div>
          </q-expansion-item>
        </div>
      </div>
    </q-expansion-item>

    <q-expansion-item dense class="exp-panel-border"  group="coastalHab" :header-class="presentClass('sand')" :expand-icon-class="presentClass('sand') === 'flag-box-present' ? 'text-white' : 'text-dark'">
      <template v-slot:header >
         <div :style="{width: '100%'}">
            <div class="text-h6 text-bold" v-if="Object.keys(coastalData['sand']).length>0">
                <span v-if="coastalData['sand'].totalSandPerc >=1">{{   coastalData['sand'].totalSandPerc }}<span class="text-body2">% of total area with SAND</span></span>
                <span v-else-if=" coastalData['sand'].totalSandPerc <1 &&  coastalData['sand'].totalSandPerc >0">&lt;1<span class="text-body2">% of total area with SAND</span></span>
                <span v-else class="text-body2">No sand dune habitat estimated</span>
                
            </div>
          </div>
      </template>

      <div class="text-center text-body1  q-mb-md">
        Sand / dunes
        <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['sand'].model = !dataConsiderations['sand'].model" aria-label="Sand / dunes data help"/>
      </div>
      <q-separator/>
      <div v-if="Object.keys(coastalData['sand']).length >0" class="row text-left text-body1 q-pa-sm q-pt-md">                
        <div class="col text-body2">Sand / dunes: {{ Math.round(coastalData['sand']['totalSandArea']/1000000 *100)/100 }} km<sup>2</sup>&nbsp;
          <span >({{ coastalData['sand']['totalSandPerc']  }}%)</span>&nbsp;
        </div>
        <div  class="col-1 items-center self-center bordered  pointer" @click="rowClick('SAND')"  :class="mapStyleInfo['attr'] == 'SAND' ? 'mapActive' : ''">
          <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'SAND'" name="chevron_right"></q-icon>
          <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
        </div>
      </div>
    </q-expansion-item>


  
    <q-expansion-item dense class="exp-panel-border"  group="coastalHab" :header-class="presentClass('rocky')" :expand-icon-class="presentClass('rocky') === 'flag-box-present' ? 'text-white' : 'text-dark'">
      <template v-slot:header >
        <div class="text-h6 text-bold" v-if="Object.keys(coastalData['rocky']).length>0" :style="{width: '100%'}">
          <span v-if="coastalData['rocky'].rockyAllPerc >=1">{{   coastalData['rocky'].rockyAllPerc }}%<span class="text-body2">% of total area with ROCKY HABITAT</span></span>
          <span v-else-if=" coastalData['rocky'].rockyAllPerc <1 &&  coastalData['rocky'].rockyAllPerc >0">&lt;1<span class="text-body2">% of total area with ROCKY HABITAT</span></span>
          <span v-else class="text-body2">No rocky habitat estimated</span>
          
        </div>
      </template>  

      <div class="text-center text-body1 q-mb-md">
        Rocky habitat
        <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['rocky'].model = !dataConsiderations['rocky'].model" aria-label="Rocky intertidal data help"/>

      </div>
      <q-separator/>
      <div v-if="Object.keys(coastalData['rocky']).length >0" class="row text-left text-body1 q-pa-sm q-pt-md">                
          <div class="col text-body2">Rocky habitats: {{ Math.round(coastalData['rocky']['rockyAllArea']/1000000 *100)/100 }} km<sup>2</sup>&nbsp;
              <span >({{ coastalData['rocky']['rockyAllPerc']  }}%)</span>&nbsp;
          </div>
          <div  class="col-1 items-center self-center bordered  pointer" @click="rowClick('ROC')"  :class="mapStyleInfo['attr'] == 'ROC' ? 'mapActive' : ''">
            <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'ROC'" name="chevron_right"></q-icon>
            <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
          </div>
      </div>
    </q-expansion-item>



     <q-expansion-item dense class="exp-panel-border" group="coastalHab" :header-class="presentClass('features')" :expand-icon-class="presentClass('features') === 'flag-box-present' ? 'text-white' : 'text-dark'">
      <template v-slot:header >
        <div class="text-h6 text-bold" v-if="Object.keys(coastalData['rocky']).length>0" :style="{width: '100%'}">
            <div  :class="presentClass('features')">
              <div class="text-body2" v-if="presentClass('features') === 'flag-box-present'">IMPORTANT FEATURES</div>
              <span v-else class="text-body2">No important coastal features</span>
            </div>
        </div>
      </template>  
      <div class="text-center text-body1 q-mb-md">
        Important Features
        <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['features'].model = !infoDialogs['features'].model" aria-label="Important features data help"/>
      </div>
      <q-separator/>
      <div v-if="Object.keys(coastalData['features']).length >0">
        <div  class="text-body1 row q-pa-sm text-left ">
          <div class="col text-body2">Coastal barrier islands:&nbsp;
            {{ Math.round(coastalData['features']['barrierIslandArea']/1000000 *100)/100 }} km<sup>2</sup>&nbsp;
                <span >({{ coastalData['features']['barrierIslandPerc']  }}%)</span>&nbsp;
                
          </div>
          <div class="col-1"> <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="dataConsiderations['BARR'].model = !dataConsiderations['BARR'].model" aria-label="Barrier island data help"/></div>
          <div  class="col-1 items-center self-center bordered  pointer" @click="rowClick('BARR')"  :class="mapStyleInfo['attr'] == 'BARR' ? 'mapActive' : ''">
              <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'BARR'" name="chevron_right"></q-icon>
              <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
          </div>
        </div>
        <div  class="text-body1 row q-pa-sm  text-left">
          <div class="col text-body2">Small islands:&nbsp;
            {{ Math.round(coastalData['features']['smallIslandsArea']/1000000 *100)/100 }} km<sup>2</sup>&nbsp;
                <span >({{ coastalData['features']['smallIslandsPerc']  }}%)</span>&nbsp;
            </div>
            <div class="col-1"> <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="dataConsiderations['SMISL'].model = !dataConsiderations['SMISL'].model" aria-label="Small island data help"/></div>
            <div  class="col-1 items-center self-center bordered  pointer" @click="rowClick('SMISL')"  :class="mapStyleInfo['attr'] == 'SMISL' ? 'mapActive' : ''">
              <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'SMISL'" name="chevron_right"></q-icon>
              <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
            </div>
        </div>
        <div  class="text-body1 row q-pa-sm text-left ">
            <div class="col text-body2">Estuaries: {{ Math.round(coastalData['features']['estuaryArea']/1000000 *100)/100 }} km<sup>2</sup>&nbsp;
                <span >({{ coastalData['features']['estuaryPerc']  }}%)</span>&nbsp;
            </div>
            <div class="col-1"> <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="dataConsiderations['ESTU'].model = !dataConsiderations['ESTU'].model" aria-label="Estuary data help"/></div>
            <div  class="col-1 items-center self-center bordered  pointer" @click="rowClick('ESTU')"  :class="mapStyleInfo['attr'] == 'ESTU' ? 'mapActive' : ''">
              <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'ESTU'" name="chevron_right"></q-icon>
              <q-icon color="white" class="self-center q-pb-md" v-else name="star" ></q-icon>
            </div>
        </div>
      </div>
    </q-expansion-item>

  </div>
          
  <div v-for="(infoObj, name) in infoDialogs" :key="name" >
      <q-dialog v-model="infoObj.model">
          <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
      </q-dialog>
  </div>
  <div v-for="(infoObj, name) in dataConsiderations" :key="name" >
      <q-dialog v-model="infoObj.model">
          <q-card>
          <q-card-section>
              <CoastalDataConsiderations :groupsToShow="name" />
          </q-card-section>
          <q-card-actions align="right">
              <q-btn flat label="OK" color="primary" @click="infoObj.model = false" />
          </q-card-actions>
          </q-card>
      </q-dialog>
  </div>
</template>
<script setup lang="ts">
// @ts-nocheck
import { toRefs, ref, computed, onMounted, useAttrs, onUnmounted } from "vue";
import { useRouter } from 'vue-router';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { AllCodes } from "../assets/SppCodesToNames.json"
import { stops } from "../assets/ColorStops.json"
import { mapLayerNames, colorStops, classNames, wetlandBarColors, sandBarColors, wetlandVulnBarColors, savPersistenceBarColors, savDecadesBarColors } from "../assets/CoastalHabitatConfig.json"
import InfoDialog from "./InfoDialog.vue";
import StackedBar from "./StackedBar.vue";
import CoastalDataConsiderations from "./CoastalDataConsiderations.vue";
const attrs = useAttrs();
const {  loadDataByID, clearMapStyle, setDataQuality, activeLayerID, styleMap, setLegend, mapStyleInfo, processedData, setProcessedData, activeCoastalHabitat, setActiveCoastalHabitat } = useMapItems()
const {  sumArray, countOccurrences, arrayFindObjectByProp } = useHelpers();

const props = defineProps({
    data: { type: Object },
    version: { type: Number },
})
const { data, version  } = toRefs(props)

const coastalData = computed(() =>{
   if (
        !processedData.value[version.value] || 
        processedData.value[version.value]['COASTAL'] === undefined ||
        processedData.value[version.value]['COASTAL'] === undefined ||
        processedData.value[version.value]['COASTAL']["a"]["results"] === undefined
    ){  
      // console.log(data.value)
        const cellData = data.value['COASTAL'];
        // console.log(cellData)

        let results
 
        if (cellData != undefined && cellData.length >0){
            const wetlandData = {}
            const wetlandVulnData = {}
            const finWetlandData = []
            const finWetlandVulnData = []
            
            const savPersistenceData = []
            const finSAVPersistence = []
            const savSurveyData = []
            const finSAVSurveyData = []
            const anyMarsh = []
            const anySand =[]
            const currentSAV = []
            const rockyAll = []
            const smallIslands = []
            const barrierIslands = []
            const estuaries = []
            const totalArea = []
            let wetlandCellCount = 0
            //  create arrays for each wetland, sand, ect  classes for bars
            for (const [key, value] of Object.entries(classNames['CMAX'])) { // class names for wetlands
              wetlandData[key] = []
            }
            // class names for wetland vulnerability
            wetlandVulnData['UVVR'] = []
               

            // populate data arrays with cell values.  Also put all areas into an array for total of any marsh
            cellData.forEach((cell) =>{
              totalArea.push(cell['AREA_SQM'])

              // seagrass area
              if (cell['SEAG'] > 0){
                currentSAV.push(cell['SEAG'])
              }

              //seagrass persistence... only calculate if there is seagrass present
              if (cell['PERS'] > -9 && cell['SEAG'] > 0){
                savPersistenceData.push(cell['PERS'])
              }
     

              //seagrass decades surveyed... 
              if (cell['LASTSV'] > 0){
                savSurveyData.push(cell['LASTSV'])
              }

              // Rocky habiatt data
              if (cell['ROC'] > 0){
                rockyAll.push(cell['ROC'])
              }
              
              // small islands
              if (cell['SMISL'] > 0){
                smallIslands.push(cell['SMISL'])
              }

              // estuaries
              if (cell['ESTU'] > 0){
                estuaries.push(cell['ESTU'])
              }

              // barrier island data
              if (cell['BARR'] > 0){
                barrierIslands.push(cell['BARR'])
              }

              //wetland data
              for (const [key, value] of Object.entries(classNames['CMAX'])) {
                if (cell[key] > 0){
                  wetlandData[key].push(cell[key])
                  anyMarsh.push(cell[key])
                }
              }
         
              // vulnerability data 
              if (cell['UVVR'] > 0){
                wetlandVulnData['UVVR'].push(cell['UVVR']) 
                wetlandCellCount += 1
              }

              // sand data 
              if (cell['SAND'] > 0){
                anySand.push(cell['SAND'])
              }              
            })


            // total area used to calc %s
            const totalAreaSum = sumArray(totalArea)

            // total area of all marsh -- used to get the % of each marsh type
            const totalMarshSum = sumArray(anyMarsh)
            
            // sum the area of each wetland class, sand class
            for (const [key, arr] of Object.entries(wetlandData)) {
              finWetlandData.push({
                category: [classNames['CMAX'][key]],
                value: Math.round((sumArray(arr) / totalMarshSum) *100 *10)/10
              })
            }

            for (const [attr, name] of Object.entries(classNames['UVVR'])) {
              const catObj = {
                category : name,
                value : Math.round(countOccurrences(wetlandVulnData['UVVR'], parseInt(attr)) / wetlandCellCount  * 100)
              }
              finWetlandVulnData.push(catObj)
            }
            // console.log(wetlandVulnData['UVVR'])
            // console.log(wetlandCellCount)
            // console.log(finWetlandVulnData)

            // sav persistence bar chart
            for (const [attr, name] of Object.entries(classNames['PERS'])) {
              finSAVPersistence.push({
                category : [name],
                value : Math.round(countOccurrences(savPersistenceData, parseInt(attr)) / savPersistenceData.length *100)
              })
            }
            let savHVHPersistence = Math.round((countOccurrences(savPersistenceData, 1) + countOccurrences(savPersistenceData, 2)) / savPersistenceData.length *100)
            
            // sav decades surveyed bar chart
            for (const [attr, name] of Object.entries(classNames['LASTSV'])) {
              finSAVSurveyData.push({
                category : [name],
                value : Math.round(countOccurrences(savSurveyData, parseInt(attr)) /savSurveyData.length *100)
              })
            }
            // console.log(savSurveyData)
            // console.log(finSAVSurveyData)



            // calculate the % of AOI that is any marsh
            
            const wetlandResults = {
              wetlandBar: finWetlandData,
              wetlandVulnBar: finWetlandVulnData,
              totalWetlandPerc: Math.round((totalMarshSum / totalAreaSum) *100 *10)/10,
              totalWetlandArea: Math.round(totalMarshSum),
              wetlandCellCount: wetlandCellCount
            }
            
            const savResults = {
              currentSAVArea : Math.round(sumArray(currentSAV)),
              currentSAVPerc : Math.round((sumArray(currentSAV) / totalAreaSum) *100 *10)/10,
              savPersistenceBar: finSAVPersistence,
              savHVHPersistence: savHVHPersistence,
              savDecadesBar:finSAVSurveyData
            }

            const rockyResults = {
              rockyAllArea : Math.round(sumArray(rockyAll)),
              rockyAllPerc: Math.round((sumArray(rockyAll) / totalAreaSum) *100 *10)/10,
            }

            const features = {
              smallIslandsArea : Math.round(sumArray(smallIslands)),
              smallIslandsPerc: Math.round((sumArray(smallIslands) / totalAreaSum) *100 *10)/10,
              barrierIslandArea: Math.round(sumArray(barrierIslands)),
              barrierIslandPerc: Math.round((sumArray(barrierIslands) / totalAreaSum) *100 *10)/10,
              estuaryArea: Math.round(sumArray(estuaries)),
              estuaryPerc: Math.round((sumArray(estuaries) / totalAreaSum) *100 *10)/10
            }


            const sandResults ={
              totalSandArea: Math.round(sumArray(anySand)),
              totalSandPerc: Math.round((sumArray(anySand) / totalAreaSum) *100 *10)/10
            }

            results = {
              wetlands : wetlandResults,
              sav: savResults,
              rocky: rockyResults,
              sand: sandResults,
              features: features
            }
            // console.log(results)
            setProcessedData(version.value, 'COASTAL', 'a', 'results', results)
        }
        

        return results
    }
    else{
      return processedData.value[version.value]['COASTAL']['a']['results']
    }
})


const boxCategory = computed({
    get: () => {
        return activeCoastalHabitat.value
    },
    set: (value) => {
        setActiveCoastalHabitat(value)
    }
});

const setBoxDet = (flagCat) =>{
    boxCategory.value = flagCat;
}

const boxClass = (name) =>{
  let c = ""
  if (boxCategory.value == name){
    c += ' flag-box-highlight'
  } 
  return c
}

const presentClass = (name) =>{
  // this applies the logic for the green highlight in the box if the feature is present
  if (name =='wetlands' && Object.keys(coastalData.value['wetlands']).length>0 && coastalData.value['wetlands']['totalWetlandPerc']>0){
    return 'flag-box-present'
  }
  if (name == 'sav'  && Object.keys(coastalData.value['sav']).length>0 && coastalData.value['sav']['currentSAVArea']>0){
    return 'flag-box-present'
  }
  if (name == 'rocky'  && Object.keys(coastalData.value['rocky']).length>0 && coastalData.value['rocky']['rockyAllArea']>0){
    return 'flag-box-present'
  }
  if (name == 'sand'  && Object.keys(coastalData.value['sand']).length>0 && coastalData.value['sand']['totalSandPerc']>0){
    return 'flag-box-present'
  }
  if ((name == 'features'  && Object.keys(coastalData.value['features']).length>0)
     && (coastalData.value['features']['barrierIslandPerc']>0 ||
         coastalData.value['features']['smallIslandsPerc']>0 ||
         coastalData.value['features']['estuaryPerc']>0 
    ))
  {
    return 'flag-box-present'
  }
  else{
    return 'no-hab-header'
  }
}

const rowClick = (attr) =>{
    let lyrID
    if (activeLayerID.value.includes("QUALITY")){
        lyrID = activeLayerID.value.replace("_QUALITY", "")
        setDataQuality(false)
        loadDataByID(lyrID, version.value)
    }
    else{lyrID = activeLayerID.value}

    let type = 'categorical'
    if (["SAND", "ESTU", "BARR", "SMISL", "ROC", "SEAG"].includes(attr)){
      type = "interpolate"
    }
    console.log(lyrID)
    console.log(attr)
    console.log(colorStops[attr])
    console.log(classNames[attr])
    console.log(type)
    styleMap(lyrID, attr, type, colorStops[attr], classNames[attr]), 
    setLegend(mapLayerNames[attr], colorStops[attr], classNames[attr])
}
const dataConsiderations = ref({
    wetlands : {
        model:false
    },
    sav: {
        model:false
    },
    sand :{
        model:false
    },
    rocky:{
        model: false
    },
    BARR:{
        model: false
    },
    SMISL:{
        model: false
    },
    ESTU:{
        model: false
    },

})
const infoDialogs = ref({
    wetlands: {
        pName: "Coastal Marshes",
        model: false,
        text: "Area estimated to present wetlands (both estuarine and palustrine). This data originates from NOAA's C-CAP (Coastal Change Analysis Program) and it is based on classifications of remote sensing data from 2016. <div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.  Similarly, only the class with the maximum value is shown when displayed in the map.  Therefore, even if the map is coded as 'Palustrine Froested Wetland', there can be smaller amounts of another habitat type within the cell.</div>"
    },
    wetlandVuln: {
        pName: "Coastal Marsh Vulnerability",
        model: false,
        text: "This data originates from the Unvegetated to Vegetation Ratio data developed by USGS. It is based from remote sensing data from 2014 to 2018. "
    },
    sav: {
        pName: "Submerged aquatic vegetation",
        model: false,
        text: "The most recent extent of seagrass / sub-aquatic vegetation within the area of interest. It is based on state-based surveys, so the data quality varies by state. Most data were hand-digitized from aerial imagery, but there are some cases (e.g. CT) where data originates from remote sensing analyses.  Be aware that surveys may have been released after this analysis was conducted, so they may not be included here.<div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.</div>"
    },
    savPers: {
        pName: "Submerged aquatic vegetation: Persistence",
        model: false,
        text: "Persistence of seagrass beds in the area. There were calculated by dividing the number of years an area had observed seagrass, by the number of years the area was surveyed. Only areas that had more than 3 years of surveys were analyzed. Analysis was performed by The Nature Conservancy. <div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.</div>"
    },
    savLast: {
        pName: "Submerged aquatic vegetation: Last Surveyed",
        model: false,
        text: "Decade when the area was last surveyed. Be aware that surveys may have been released after this analysis was conducted, so they may not be included here.<div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.</div>"
    },
    sand: {
        pName: "Sand / dunes",
        model: false,
        text: "Sandy beach data are based on an analysis by The Nature Conservancy, which combined land-cover data with a survey of known beach areas in the region. <div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.</div>"
    },
    rocky :{
        pName: "Rocky Habitats",
        model: false,
        text: "Rocky intertidal habitat within the area of interest. This data originates from The Nature Conservancy's Northeast Habitat Map (Ferree and Anderson, 2013). <div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.</div>"
    },
    smallIslands :{
        pName: "Small Islands",
        model: false,
        text: "<div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.</div>"
    },
    features :{
        pName: "Important features",
        model: false,
        text: "Coastal features include Coastal Barriers, Small Islands, and Estuaries. Coastal barriers are unique landforms that provide protection for diverse aquatic habitats against the impacts of severe coastal storms and erosion. Coastal Barrier data originates from an analysis by The Nature Conservancy, and it includes barriers that are part of the Coastal Barrier Resources Act (CBRA). Small Island data originate from USGS as part of their Global Islands analysis (Thomas Martin et al. 2020). Estuaries data originate from The National Fish and Wildlife Foundation (NWFW). <div class='q-pt-sm'>Measurements for this attribtue are based on the areal sum of the feature present within cells of the area of interest. If two cells within the area of interest each have 1sq km of a feature the result will be 2 sq km, even if the area of interest only partially overlaps each of the cells.</div>"
    }
})
onMounted(() => {
  if (activeLayerID.value != 'COASTAL'){
    loadDataByID('COASTAL', version)
  }
})

onUnmounted(() => {
    mapStyleInfo.value['attr'] = null;
    mapStyleInfo.value['layer'] = null;
})
</script>
<style scoped>
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;
 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
 .result-pane-header-row{
  border-top: 1px solid white;
}
.pointer{
  cursor: pointer;
}
.flag-box{
    height: 80px;
    outline: 1px solid black;
    outline-offset: -4px;
    padding: 4px;
    min-height: 60px;
}
.flag-detBox{
    border: 3px solid black;
    min-height: 300px;
}

.flag-box-highlight{
    outline: 3px solid black;
    outline-offset: -4px;
}
:deep(.flag-box-present){
    background-color: #1D8177;
    color: white;
    height: 100%;
    width: 100%;
}
.mapActive{
    background-color: #1D8177;
}
.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
.exp-panel-border{
  border: 1px solid rgb(39, 39, 39);
  margin-top:2px;
}
.connection-line{
    rotate: 90deg;
    max-width: 11px;
    height: 3px;
    position: relative;
}
:deep(.no-hab-header){
  background-color: #d6d6d6;
}
.box-1{
    left: 7%;
}
.box-2{
    left: 24%;
}
.box-3{
    left: 40%;
}
.box-4{
    left: 57%;
}
.box-5{
    left: 74%;
}
.box-6{
    left: 90%;
}

</style>